import React from 'react'
import HomeBanner from './home/HomeBanner'
import HomeAbout from './home/HomeAbout'
// import HomeAbout from './home/HomeAbout'
// import MissionVision from './home/MissionVision'
import HomeWorkingProcess from './home/HomeWorkingProcess'
import ChooseUs from './home/ChooseUs'
import HomeMDMessage from './home/HomeMDMessage'
import HomeTestimonials from './home/HomeTestimonials'
import OurPortfolio from './home/OurPortfolio'
import HomeServices from './home/HomeServices'
import HomeBlog from './home/HomeBlog'
import Accreditations from './home/Accreditations'
// import OurDepartments from './home/OurDepartments'
// import HomeFaq from './home/HomeFaq'
// import HomeTestimonials from './home/HomeTestimonials'
// import OurFacilites from './home/OurFacilites'
// import OutTeam from './home/OutTeam'
// import HomeBlog from './home/HomeBlog'
// import PressRelease from './home/PressRelease'
// import DepartmentsHome from './home/DepartmentsHome'



const Home = () => {
  return (
    <>
      <div style={{ overflow: "hidden" }}>
        <HomeBanner />
        <HomeMDMessage />
        <HomeAbout />
        <Accreditations />
        <ChooseUs />
        <HomeWorkingProcess />
        <HomeServices />
        <HomeTestimonials />
        <HomeBlog />
        <OurPortfolio />
        
      </div>






    </>
  )
}

export default Home